import { render, staticRenderFns } from "./MyCocoCoin.vue?vue&type=template&id=22778ea8&scoped=true&"
import script from "./MyCocoCoin.vue?vue&type=script&lang=js&"
export * from "./MyCocoCoin.vue?vue&type=script&lang=js&"
import style0 from "./MyCocoCoin.vue?vue&type=style&index=0&id=22778ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22778ea8",
  null
  
)

export default component.exports